module.exports = __webpack_public_path__ + "static/img/audio-flay.70423713.png";